import type { Schemas } from '#shopware'

export const productSortingIncludes: Schemas['Includes'] = {
    product_sorting: ['key', 'label', 'translated'],
}
